import React, { Fragment ,useState} from 'react';
import PropTypes from 'prop-types';

//import Vimeo from '@u-wave/react-vimeo';
import YouTube from 'react-youtube';
import getYoutubeId from 'get-youtube-id';

import {
  FacebookIcon,
  FacebookShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton
} from 'react-share';

import {
  DownloadButton,
  TextWithReadMore,
  ConcertDetailedBanner,
  ClipboardBtn
} from '../../../components';

const LiveEvent = ({ data, videoUrl, otherData }) => {
  const [contWidth, setContWidth] = useState('69vw')
  const {
    windowWidth,
    windowHeight,
    concert,
    customEventData,
    concertProgram,
    pageUrl,
  } = otherData;

  const youtubeOptions = {
    height: '100%',
    width: '100%',
    playerVars: {
      muted: 1,
      autoplay: 1,
    },
  };

  const { about, program, artists } =
    concert !== null && concert !== undefined ? concert : '';

  const title = customEventData
    ? customEventData.title
    : concert && concert.title;

  const desc = customEventData?.desc;
  
  const setWidth = () =>{
    setContWidth('70vw')
  }
  return (
    <div className={`live_page_container  liveEvent`} style={{width:contWidth}}>
      <div className='live_page_player'>
        {videoUrl &&
          (videoUrl.match('^(https?://)?((www.)?youtube.com|youtu.?be)/.+$') ? (
            <YouTube
              className='live_page_player__youtube'
              videoId={getYoutubeId(videoUrl)}
              opts={youtubeOptions}
            />
          ) : videoUrl.match('vimeo.com') ? (
		//testing without vimeo
		  <video
              autoPlay
              controls
              muted
              // poster={liveEvent.next}
              className='live_page_player__default'
              	src={videoUrl}
            	/>
//            <Vimeo
//              className='live_page_player__vimeo'
//              video={videoUrl}
//              autoplay
//              style={{ width: '100vw', paddingTop: '56%' }}
//              muted
//              onLoaded={()=>setWidth()}
//            />
          ) : (
            <video
              autoPlay
              controls
              muted
              // poster={liveEvent.next}
              className='live_page_player__default'
              src={videoUrl}
            />
          ))}
      </div>{' '}
      <>
        <div className='concert'>
          <div className='live_page_head'>
            {customEventData && (
              <div>
                <h1 className='live_page_title'>{title && title}</h1>

                {desc && (
                  <p
                    className='pr-4 mb-5'
                    dangerouslySetInnerHTML={{ __html: desc }}
                  />
                )}
              </div>
            )}

            {(concert || customEventData) && (
              <div className='concert__section concert__sharing'>
                <h3 className='sharing__title'>SHARE ON:</h3>
                <div className='sharingBtns'>
                  <FacebookShareButton
                    windowWidth={windowWidth}
                    windowHeight={windowHeight}
                    url={pageUrl}
                  >
                    <FacebookIcon />
                  </FacebookShareButton>

                  <TwitterShareButton
                    windowWidth={windowWidth}
                    windowHeight={windowHeight}
                    url={pageUrl}
                  >
                    <TwitterIcon />
                  </TwitterShareButton>

                  <WhatsappShareButton
                    windowWidth={windowWidth}
                    windowHeight={windowHeight}
                    url={pageUrl}
                  >
                    <WhatsappIcon />
                  </WhatsappShareButton>

                  <ClipboardBtn url={pageUrl} btnClass='clipboardBtn' />
                </div>
              </div>
            )}
          </div>
          {!customEventData && (
            <section className='concert__main'>
              <section className='concert__hero'>
                <div className='concert__head' id='concert__head'>
                  <div className='concert__detailed__banner'>
                    <ConcertDetailedBanner
                      concertDetails={concert !== null && concert}
                    />
                  </div>
                </div>
              </section>
              <div className='concert__details'>
                {about ? (
                  <div className='concert__section concert__about'>
                    <h2>About</h2>
                    <TextWithReadMore
                      shortText={about}
                      longText={about}
                      textClass='concert__about__text'
                      useLong
                    />
                  </div>
                ) : (
                  ''
                )}

                {program && program.length ? (
                  <div className='concert__section concert__programme'>
                    <h2>Programme</h2>

                    {program.map((prog, i) => (
                      <div key={i} className='prog'>
                        {prog.upcoming ? (
                          <h3 key={i}>Comming Soon...</h3>
                        ) : (
                          <>
                            <h5 className='prog__subtitle__part'>
                              {prog.part}
                            </h5>

                            {prog.data.map((p, i) => (
                              <Fragment key={i}>
                                <h3 className='prog__composer'>{p.author}</h3>
                                <h4 className='prog__music'>{p.performance}</h4>
                                {prog.music_parts && prog.music_parts.length ? (
                                  <ul>
                                    {prog.music_parts.map((part, i) => (
                                      <li key={i}>{part.name}</li>
                                    ))}
                                  </ul>
                                ) : (
                                  ''
                                )}
                              </Fragment>
                            ))}
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  ''
                )}

                {artists &&
                  artists.map(
                    (conductor) =>
                      conductor.role === 'conductor' && (
                        <div
                          key={conductor.id}
                          className='concert__section concert__conductor'
                        >
                          <h3
                            dangerouslySetInnerHTML={{
                              __html: `${conductor.name} ${conductor.surname}`,
                            }}
                          />
                          <h4>CONDUCTOR</h4>

                          {conductor.bio !== '' && (
                            <TextWithReadMore
                              shortText={conductor.bio}
                              longText={conductor.bio}
                              textClass='concert__conductor__text'
                            />
                          )}
                        </div>
                      )
                  )}
                <div className='concert__section concert__soloists'>
                  {artists &&
                    artists.map(
                      (sol, i) =>
                        sol.role === 'soloist' && (
                          <div key={i} className='concert__soloist'>
                            <h3
                              className='sol__name'
                              dangerouslySetInnerHTML={{
                                __html: `${sol.name} ${sol.surname}`,
                              }}
                            />
                            <TextWithReadMore
                              shortText={sol.bio}
                              longText={sol.bio}
                              textClass='concert__sol__text'
                            />
                          </div>
                        )
                    )}
                </div>

                <div className='concert__section concert__orchestras'>
                  {artists &&
                    artists.map(
                      (orc, i) =>
                        orc.role === 'orchestra' && (
                          <div key={i} className='concert__orchestra'>
                            <h3 className='orc__name'>{orc.name}</h3>
                            <TextWithReadMore
                              shortText={orc.bio}
                              longText={orc.bio}
                              textClass='concert__orc__text'
                            />
                          </div>
                        )
                    )}
                </div>

                {concertProgram &&
                  Object.keys(concertProgram).length &&
                  concertProgram.url !== '' && (
                    <div className='concert__section concert__download'>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: concertProgram && concertProgram?.label,
                        }}
                      />

                      <DownloadButton
                        downloadUrl={concertProgram && concertProgram?.url}
                        btnTitle='download'
                      />
                    </div>
                  )}
              </div>
            </section>
          )}
        </div>
      </>
    </div>
  );
};

LiveEvent.propTypes = {
  data: PropTypes.object.isRequired,
  videoUrl: PropTypes.string.isRequired,
  otherData: PropTypes.object.isRequired,
};

export default LiveEvent;
